{
  "#TIMESTAMP": {
    "APP": "Stempel",
    "TITLE": "Stempelerfassung",
    "TITLE_QUERY": "Abfrage",
    "TITLE_RESULT": "Ergebnisse",
    "RECORD_TIMESTAMP": "Erfassen",
    "QUERY": "Suchen",
    "QUERY_RESULT": "Ergebnisse",
    "BACK": "Zurück",
    "NO_DATA": "Es wurden keine Zeitstempel erfasst.",
    "DEFAULT_CODE": "Normal",
    "ACTIONS": "Aktionen",
    "TABLE": {
      "TITLE": "Stempel",
      "FROM": "Von",
      "TO": "Bis",
      "APPLIED_FILTERS": "Angewendete Filter",
      "HEADER": {
        "TYPE": "Typ",
        "CODE": "Code",
        "DATE": "Datum",
        "TIME": "Stempel"
      }
    },
    "TYPE": {
      "ARRIVAL": "Kommt",
      "DEPARTURE": "Geht"
    },
    "FIND": {
      "SUBMIT": "Suchen",
      "EMPLOYEE_NUMBER": "Personalnummer",
      "FROM": "Von",
      "TO": "Bis"
    },
    "RECORD": {
      "TITLE": "Stempel erfassen",
      "EMPLOYEE": "Personalnummer",
      "TYPE": "Status",
      "CODE": "Code",
      "TIMESTAMP": "Stempel",
      "SUBMIT": "Erfassen"
    },
    "MESSAGES": {
      "ADD_SUCCESS": {
        "TITLE": "Erfolgreich",
        "MESSAGE": "Der Zeitstempel wurde erfasst."
      },
      "REMOVE_SUCCESS": {
        "TITLE": "Erfolgreich",
        "MESSAGE": "Der Zeitstempel wurde gelöscht."
      },
      "ADD_FAILURE": {
        "TITLE": "Fehler",
        "MESSAGE": "Der Zeitstempel konnte nicht erfasst werden."
      },
      "REMOVE_FAILURE": {
        "TITLE": "Fehler",
        "MESSAGE": "Der Zeitstempel konnte nicht gelöscht werden."
      }
    },
    "ASK": {
      "CONFIRM_DELETE": "Möchten Sie diesen Zeitstempel wirklich löschen?"
    },
    "NAVIGATE": {
      "PREVIOUS_DAY": "Vorheriger Tag",
      "NEXT_DAY": "Nächster Tag"
    }
  },
  "#WORKHOURS": {
    "TITLE": "Heutige Arbeitsstunden",
    "WEEK": "Wochenstunden",
    "PAUSE": "Heutige Pausenzeit",
    "TARGET": "Ziel",
    "OF_TARGET": "vom Ziel"
  }
}
